import { useLocalStorage } from 'shared/hooks/useLocalStorage'
import { RecentSearch } from '../types'

const STORAGE_KEY = 'globalSearch:recentSearches'
const MAX_RECENT_SEARCHES = 10

export function useRecentSearches() {
    const [recentSearches, setRecentSearches] = useLocalStorage<RecentSearch[]>(
        STORAGE_KEY,
        []
    )

    const addSearch = (query: string) => {
        const trimmed = query.trim()
        if (!trimmed) return

        setRecentSearches((prev) => {
            const filtered = prev.filter((s) => s.query !== trimmed)
            const newSearch: RecentSearch = {
                query: trimmed,
                timestamp: Date.now(),
            }
            return [newSearch, ...filtered].slice(0, MAX_RECENT_SEARCHES)
        })
    }

    const removeSearch = (query: string) => {
        setRecentSearches((prev) => prev.filter((s) => s.query !== query))
    }

    const clearAll = () => {
        setRecentSearches([])
    }

    return {
        recentSearches,
        addSearch,
        removeSearch,
        clearAll,
    }
}
